enum RDevNotificationType {
  InternetOutage = 1,
  OsVersionChanged,
  RDevVersionChanged
}

export default RDevNotificationType;